import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { ToastComponent } from '../../shared/toast/toast.component';
import { OrganizationService } from '../../services/organization.service';
import { setClassInvalid } from '../../shared/functions';
import { ee, urlRegexp, usernameRegexp } from '../../shared/constants';
import { finalize } from 'rxjs';

@Component({
  selector: 'app-add-organization-form',
  templateUrl: './add-organization-form.component.html',
  standalone: false
})
export class AddOrganizationFormComponent implements OnInit, OnDestroy {
  private organizationService = inject(OrganizationService);
  private formBuilder = inject(UntypedFormBuilder);
  toast = inject(ToastComponent);


  addOrganizationForm = this.createOrganizationForm();
  usernameRegexp = usernameRegexp;
  urlRegexp = urlRegexp;
  setClassInvalid = setClassInvalid;

  ngOnInit(): void {
    ee.on('searchInput', (obj: any) => this.addOrganizationForm.patchValue(obj));
  }

  ngOnDestroy(): void {
    ee.off('searchInput', () => {});
  }

  createOrganizationForm(): UntypedFormGroup {
    return this.formBuilder.group({
      name: ['', Validators.required],
      website: ['', Validators.compose([Validators.pattern(/^https?:\/\/.*/), Validators.required])],
      notes: [''],
      _politicians: [[]],
      socials: this.formBuilder.group({
        twitter: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.twitter)]
        }),
        instagram: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.instagram)]
        }),
        facebook: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.facebook)]
        }),
        linkedin: this.formBuilder.group({
          username: ['', Validators.pattern(usernameRegexp.linkedin)]
        })
      })
    });
  }

  addOrganization(): void {
    this.organizationService.add(this.addOrganizationForm.value)
      .pipe(finalize(() => {
        ee.emit('getOrganizations');
        ee.emit('organizationAdded', true);
      }))
      .subscribe({
        next: res => this.toast.setMessage('Organization added successfully!', 'success'),
        error: err => this.toast.setMessage(err.error.message, 'danger')
      });
  }
}
